import _objectSpread from "/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import * as React from 'react';
import FormCheck from './FormCheck';
import { jsx as _jsx } from "react/jsx-runtime";
var Switch = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(FormCheck, _objectSpread({}, props, {
    ref: ref,
    type: "switch"
  }));
});
Switch.displayName = 'Switch';
export default Object.assign(Switch, {
  Input: FormCheck.Input,
  Label: FormCheck.Label
});